/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Change_Theme_Amp_Frame_StyleInputs */

const en_change_theme_amp_frame_style = /** @type {(inputs: Change_Theme_Amp_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Theme & Frame Style`)
};

const es_change_theme_amp_frame_style = /** @type {(inputs: Change_Theme_Amp_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar Tema y Estilo de Marco`)
};

const fr_change_theme_amp_frame_style = /** @type {(inputs: Change_Theme_Amp_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer de Thème et de Style de Cadre`)
};

const de_change_theme_amp_frame_style = /** @type {(inputs: Change_Theme_Amp_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design & Rahmenstil ändern`)
};

const ja_change_theme_amp_frame_style = /** @type {(inputs: Change_Theme_Amp_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーマとフレームスタイルを変更`)
};

const zh_change_theme_amp_frame_style = /** @type {(inputs: Change_Theme_Amp_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改主题与相框风格`)
};

const ar_change_theme_amp_frame_style = /** @type {(inputs: Change_Theme_Amp_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير السمة ونمط الإطار`)
};

const id_change_theme_amp_frame_style = /** @type {(inputs: Change_Theme_Amp_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubah Tema & Gaya Bingkai`)
};

const it_change_theme_amp_frame_style = /** @type {(inputs: Change_Theme_Amp_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia Tema e Stile Cornice`)
};

const ru_change_theme_amp_frame_style = /** @type {(inputs: Change_Theme_Amp_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить Тему и Стиль Рамки`)
};

const pt_change_theme_amp_frame_style = /** @type {(inputs: Change_Theme_Amp_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudar Tema e Estilo de Moldura`)
};

const ko_change_theme_amp_frame_style = /** @type {(inputs: Change_Theme_Amp_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`테마 및 프레임 스타일 변경`)
};

/**
* | output |
* | --- |
* | "Change Theme & Frame Style" |
*
* @param {Change_Theme_Amp_Frame_StyleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const change_theme_amp_frame_style = /** @type {((inputs?: Change_Theme_Amp_Frame_StyleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Change_Theme_Amp_Frame_StyleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_change_theme_amp_frame_style(inputs)
	if (locale === "es") return es_change_theme_amp_frame_style(inputs)
	if (locale === "fr") return fr_change_theme_amp_frame_style(inputs)
	if (locale === "de") return de_change_theme_amp_frame_style(inputs)
	if (locale === "ja") return ja_change_theme_amp_frame_style(inputs)
	if (locale === "zh") return zh_change_theme_amp_frame_style(inputs)
	if (locale === "ar") return ar_change_theme_amp_frame_style(inputs)
	if (locale === "id") return id_change_theme_amp_frame_style(inputs)
	if (locale === "it") return it_change_theme_amp_frame_style(inputs)
	if (locale === "ru") return ru_change_theme_amp_frame_style(inputs)
	if (locale === "pt") return pt_change_theme_amp_frame_style(inputs)
	return ko_change_theme_amp_frame_style(inputs)
});